import { c as _c } from "react/compiler-runtime";
import { type FieldError, getFieldErrors } from '@onefootprint/core';
import { useTranslation } from 'react-i18next';
import useRequestErrorToast from '@/idv2/hooks/use-request-error-toast';
import { isOnboardingSuperseded } from '@/idv2/utils/is-onboarding-superseded';
import { getLogger } from '@/idv2/utils/logger';
export type { FieldError };

/**
 * Formats field errors for logging (e.g. "key1: msg1; key2: msg2").
 */
export const formatFieldErrorsForLog = (fieldErrors: FieldError[]): string => fieldErrors.map(e => `${e.key}: ${e.message}`).join('; ');
const {
  logWarn
} = getLogger({
  name: 'idv2',
  location: 'vault-mutation-error'
});
export const useTranslateFieldError = () => {
  const $0 = _c(3);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldErrors"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($0[1] !== t) {
    t1 = fieldError => {
      const {
        code,
        message
      } = fieldError;
      return code ? {
        ...fieldError,
        message: t($ => $[code as keyof typeof $], {
          defaultValue: message
        })
      } : fieldError;
    };
    $0[1] = t;
    $0[2] = t1;
  } else {
    t1 = $0[2];
  }
  return t1;
};
export const useVaultMutationError = () => {
  const $ = _c(3);
  const showRequestErrorToast = useRequestErrorToast();
  const translateFieldError = useTranslateFieldError();
  let t0;
  if ($[0] !== showRequestErrorToast || $[1] !== translateFieldError) {
    t0 = (error, onFieldError) => {
      if (isOnboardingSuperseded(error)) {
        return [];
      }
      const fieldErrors = getFieldErrors(error);
      if (fieldErrors.length > 0) {
        logWarn("Vault mutation field errors", error, {
          fieldErrors: formatFieldErrorsForLog(fieldErrors)
        });
      }
      const translatedErrors = fieldErrors.map(translateFieldError);
      showRequestErrorToast(error, translatedErrors);
      if (translatedErrors.length > 0 && onFieldError) {
        onFieldError(translatedErrors);
      }
      return translatedErrors;
    };
    $[0] = showRequestErrorToast;
    $[1] = translateFieldError;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleError = t0;
  return handleError;
};